import { render, staticRenderFns } from "./ScreenSaverList.vue?vue&type=template&id=303bd1d6&scoped=true&"
import script from "./ScreenSaverList.vue?vue&type=script&lang=ts&"
export * from "./ScreenSaverList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303bd1d6",
  null
  
)

export default component.exports